// Returns a 0-1 quality score for a mapped listing object.
// Weights: photos 40%, description 20%, required fields 20%, recency 20%.
export function computeQualityScore(listing) {
  const photoCount = (listing.images || []).length;
  const photoScore =
    photoCount === 0 ? 0 :
    photoCount <= 3  ? 0.3 :
    photoCount <= 7  ? 0.6 : 1.0;

  const descLen = (listing.description || '').length;
  const descScore =
    descLen === 0   ? 0 :
    descLen < 50    ? 0.3 :
    descLen < 200   ? 0.6 : 1.0;

  const fieldsFilled = [listing.address, listing.plotSize, listing.contact_phone, listing.contact_email]
    .filter(v => v != null && v !== '').length;
  const fieldsScore = fieldsFilled / 4;

  const now = Date.now();
  const created = listing.created_at ? new Date(listing.created_at).getTime() : 0;
  const daysSince = created > 0 ? (now - created) / 86400000 : 999;
  const recencyScore =
    daysSince <= 7  ? 1.0 :
    daysSince <= 30 ? 0.8 :
    daysSince <= 90 ? 0.5 : 0.3;

  return photoScore * 0.4 + descScore * 0.2 + fieldsScore * 0.2 + recencyScore * 0.2;
}

// Returns the final ranking score for any listing in a mixed feed.
// formula: quality_score × (1 + boost_bonus × time_decay)
// where boost_bonus = 0.5 for active boosts, time_decay = 1.0 day1 → 0.5 day30.
export function computeFinalScore(listing) {
  const qs = listing.qualityScore || 0;
  const now = new Date();
  const isBoosted = listing.is_boosted && listing.boost_expires_at && new Date(listing.boost_expires_at) > now;
  if (!isBoosted) return qs;

  const daysRemaining = (new Date(listing.boost_expires_at) - now) / 86400000;
  const daysIntoBoost = Math.max(0, 30 - daysRemaining);
  const timeDecay = Math.max(0.5, 1.0 - (daysIntoBoost / 30) * 0.5);
  return qs * (1 + 0.5 * timeDecay);
}
